/*
 * Statuspagina prive-lease (/pages/status), zie sections/lease-status.liquid.
 *
 * Liquid kan de query string niet lezen, dus de personalisatie gebeurt hier.
 * Verwachte parameters: merk, model, kleur, maat, handle, variant.
 *
 * Iedereen kan zo'n URL samenstellen. Waarden gaan daarom uitsluitend via
 * textContent/setAttribute de pagina in, nooit via innerHTML, en handle en
 * variant worden gevalideerd voordat ze in een request terechtkomen.
 */
(function () {
  if (customElements.get('lease-status')) return;

  var HANDLE_RE = /^[a-z0-9][a-z0-9-]*$/i;
  var VARIANT_RE = /^\d+$/;
  var MAX_LENGTH = 80;
  var IMAGE_WIDTH = 900;

  function readParams() {
    var query = new URLSearchParams(window.location.search);

    function get(key) {
      var value = (query.get(key) || '').trim();
      return value.length > MAX_LENGTH ? value.slice(0, MAX_LENGTH) : value;
    }

    var handle = get('handle');
    var variant = get('variant');

    return {
      merk: get('merk'),
      model: get('model'),
      kleur: get('kleur'),
      maat: get('maat'),
      handle: HANDLE_RE.test(handle) ? handle : '',
      variant: VARIANT_RE.test(variant) ? variant : ''
    };
  }

  // {merk} etc. invullen; een functie als vervanger voorkomt dat $-reeksen
  // in de parameterwaarden als speciale patronen worden uitgelegd.
  function fillTemplate(template, params) {
    return template
      .replace(/\{(merk|model|kleur|maat)\}/g, function (_, key) {
        return params[key];
      })
      .replace(/\s{2,}/g, ' ')
      .replace(/\s+([.,!?])/g, '$1')
      .trim();
  }

  function sizedImageUrl(src) {
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + IMAGE_WIDTH;
  }

  // Waarde van een variant-optie, bijvoorbeeld "Accu". Het thema matcht elders
  // op dezelfde manier (zie product-variant-options.liquid). Het .js-endpoint
  // geeft options soms als namen en soms als objecten met een name.
  function optionValue(product, variant, name) {
    var options = product.options || [];
    var index = -1;

    for (var i = 0; i < options.length; i++) {
      var optionName = typeof options[i] === 'string' ? options[i] : (options[i] && options[i].name) || '';
      if (String(optionName).trim().toLowerCase() === name) {
        index = i;
        break;
      }
    }
    if (index === -1) return '';

    var values = Array.isArray(variant.options)
      ? variant.options
      : [variant.option1, variant.option2, variant.option3];

    return String(values[index] || '').trim();
  }

  function productUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  class LeaseStatus extends HTMLElement {
    connectedCallback() {
      this.params = readParams();
      this.bikeName = [this.params.merk, this.params.model].filter(Boolean).join(' ');
      // Accu staat niet in de link; die komt uit de variant-optie in renderProduct
      this.fields = { kleur: this.params.kleur, maat: this.params.maat, accu: '' };

      this.renderIntro();
      this.renderSummary();

      if (this.params.handle) this.loadProduct();
    }

    setField(name, value) {
      this.fields[name] = value;
      this.querySelectorAll('[data-status-field="' + name + '"]').forEach(function (el) {
        el.hidden = !value;
        if (el.hasAttribute('data-status-value')) el.textContent = value;
      });
    }

    setBikeName(name) {
      this.bikeName = name;
      var bike = this.querySelector('[data-status-bike]');
      if (bike) bike.textContent = name;
    }

    hasSummaryContent() {
      return Boolean(this.bikeName || this.fields.kleur || this.fields.maat || this.fields.accu);
    }

    renderIntro() {
      var intro = this.querySelector('[data-status-intro]');
      if (!intro || !this.bikeName) return;

      var template = intro.getAttribute('data-intro-personal');
      if (template) intro.textContent = fillTemplate(template, this.params);
    }

    renderSummary() {
      var self = this;

      this.setBikeName(this.bikeName);
      ['kleur', 'maat', 'accu'].forEach(function (field) {
        self.setField(field, self.fields[field]);
      });

      this.setSummaryVisible(this.hasSummaryContent() || Boolean(this.params.handle));
    }

    loadProduct() {
      var self = this;

      fetch(productUrl(this.params.handle), { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Product niet gevonden: ' + response.status);
          return response.json();
        })
        .then(function (product) {
          self.renderProduct(product);
        })
        .catch(function () {
          self.productUnavailable();
        });
    }

    renderProduct(product) {
      var src = product.featured_image;
      // Afmetingen van de getoonde afbeelding, voor de width/height-attributen
      var dims = Array.isArray(product.media) && product.media.length ? product.media[0] : null;

      var variant = null;
      if (this.params.variant && Array.isArray(product.variants)) {
        var variantId = this.params.variant;
        variant = product.variants.find(function (v) {
          return String(v.id) === variantId;
        }) || null;

        if (variant && variant.featured_image && variant.featured_image.src) {
          src = variant.featured_image.src;
          dims = variant.featured_image;
        }
      }

      // Accu zit niet in de link maar is een variant-optie; kleur en maat
      // alleen aanvullen als de link ze niet meegaf.
      if (variant) {
        this.setField('accu', optionValue(product, variant, 'accu'));
        if (!this.fields.kleur) this.setField('kleur', optionValue(product, variant, 'kleur'));
        if (!this.fields.maat) this.setField('maat', optionValue(product, variant, 'maat'));
      }

      // Geen merk/model in de link: de producttitel als naam gebruiken
      if (!this.bikeName && product.title) this.setBikeName(product.title);

      if (!src) {
        this.productUnavailable();
        return;
      }

      var self = this;
      var img = this.querySelector('[data-status-image]');
      if (!img) return;

      img.onerror = function () {
        img.hidden = true;
        self.productUnavailable();
      };
      if (dims && dims.width && dims.height) {
        img.setAttribute('width', dims.width);
        img.setAttribute('height', dims.height);
      }
      img.setAttribute('alt', this.bikeName);
      img.setAttribute('src', sizedImageUrl(src));
      img.hidden = false;
    }

    // Handle onbekend of afbeelding kapot: samenvatting alleen houden als er
    // nog iets anders te tonen is.
    productUnavailable() {
      this.setSummaryVisible(this.hasSummaryContent());
    }

    setSummaryVisible(visible) {
      var summary = this.querySelector('[data-status-summary]');
      if (summary) summary.hidden = !visible;
      this.classList.toggle('lease-status--no-summary', !visible);
    }
  }

  customElements.define('lease-status', LeaseStatus);
})();
